import React from "react";
import api from '../../api/Api'
import Loader from '../../components/Loader'
// import {Redirect} from 'react-router';
import Icon from "@material-ui/core/Icon";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import {NavLink} from "react-router-dom";
import {getDateConverter} from "../../util/globalHelper"

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from 'match-sorter';
import {dashboardRouter, getDateConverterReversal} from "../../util/globalHelper"
export default class readOnePatient extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            clinic_data: [],
            clickedId: "",
            redirect: false,
            alert: null,
            api_url: "",
            open: true,
            data: null,
            tab: 0,
            notFound: null
        };
        this.CallReadApi = this.CallReadApi.bind(this);
        this.CallDeleteApi = this.CallDeleteApi.bind(this);
        this.onChangeTab1 = this.onChangeTab1.bind(this);
        this.onChangeTab2 = this.onChangeTab2.bind(this);
        this.onChangeTab3 = this.onChangeTab3.bind(this);

    }

    componentDidMount() {
        this.CallReadApi(this.props.match.params.patientID);
        this.setState({clickedId: this.props.match.params.patientID})
    }

    onChangeTab1() {
        this.setState({
            tab: 0
        })
    }

    onChangeTab2() {
        this.setState({
            tab: 1
        })
    }

    onChangeTab3() {
        this.setState({
            tab: 2
        })
    }

    render() {
        const {data} = this.state;
        if (this.state.data !== null) {
            return (<div>
                    <Card>
                        <CardHeader style={{paddingBottom: 0}}>
                            <GridContainer justify="center">
                                <GridItem md={11}>
                                    <h2>{data.user_id.name?data.user_id.name:""}</h2>
                                </GridItem>
                            </GridContainer>
                        </CardHeader>
                        <CardBody>
                            <GridContainer justify="center">
                                {this.state.alert}
                                <GridItem xs={12} sm={8} md={8}>
                                    <GridContainer>
                                        <GridItem xs={12} sm={6}>
                                            <GridItem>
                                                <h4><b>{data.user_id.contact}</b></h4>
                                                <p>Contact</p>
                                            </GridItem>

                                            {data.user_id.email ? <GridItem>
                                                <h4><b>{data.user_id.email}</b></h4>
                                                <p>Email</p>
                                            </GridItem> : null}
                                        </GridItem>
                                        <GridItem xs={12} sm={6}>

                                            {data.gender ? <GridItem>
                                                <h4><b>{data.gender}</b></h4>
                                                <p>Gender</p>
                                            </GridItem> : null}

                                            {data.user_id.age ? <GridItem>

                                                <h4><b>{data.user_id.age}</b></h4>
                                                <p>Age</p>
                                            </GridItem> : null}

                                        </GridItem>
                                        <GridItem xs={12} sm={6}>

                                            {data.height ? <GridItem>
                                                <h4><b>{data.height}</b></h4>
                                                <p>Height</p>
                                            </GridItem> : null}

                                            {data.weight ? <GridItem>
                                                <h4><b>{data.weight}</b></h4>
                                                <p>Weight</p>
                                            </GridItem> : null}

                                        </GridItem>

                                        <GridItem xs={12} sm={6}>
                                            {data.blood_group ? <GridItem>
                                                <h4><b>{data.blood_group}</b></h4>
                                                <p>Blood Group</p>
                                            </GridItem> : null}

                                            {data.BMI ? <GridItem>
                                                <h4><b>{data.BMI}</b></h4>
                                                <p>BMI</p>
                                            </GridItem> : null}

                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                                <GridItem xs={12} sm={4} md={3}>
                                    <GridItem>
                                        {/*<img*/}
                                        {/*data-src="holder.js/100px180/"*/}
                                        {/*style={{ display: "block",maxWidth:200,maxHeight:200}}*/}
                                        {/*src= {data.profile_image ? data.profile_image : '' }*/}
                                        {/*data-holder-rendered="true"*/}
                                        {/*onError={(e)=>{ e.onerror=null; e.target.src=require('assets/img/placeholder.jpg') }}*/}
                                        {/*/>*/}
                                    </GridItem>
                                    <GridItem>
                                        <NavLink
                                            to={dashboardRouter(`/patient/updatePatient/${data._id}`)}>
                                            <Button block color="warning"
                                                // onClick={this.RouteToUpdate(data._id)}
                                            ><Icon>border_color</Icon>
                                                <span style={{paddingLeft: 10}}>Update</span></Button>
                                        </NavLink>
                                        <br></br>
                                        <Button block color="grey"
                                                onClick={this.DeleteAlert('Delete', data._id)}
                                        >
                                            <Icon>delete</Icon>
                                            <span style={{paddingLeft: 10}}>Delete</span>
                                        </Button>
                                        <br></br>
                                        <NavLink
                                            to={dashboardRouter(`/report/add/${data._id}`)}>
                                            <Button block color="info"
                                                // onClick={this.RouteToUpdate(data._id)}
                                            >
                                                <span>Add Reports</span></Button>
                                        </NavLink>
                                        <br></br>
                                        <NavLink
                                            to={dashboardRouter(`/appointment/bookAppointment/${data._id}`)}>
                                            <Button block color="info"
                                                // onClick={this.RouteToUpdate(data._id)}
                                            >
                                                <span>Book Appointment</span></Button>
                                        </NavLink>
                                        <br></br>
                                    </GridItem>
                                </GridItem>
                            </GridContainer>
                            <GridContainer>
                                <GridItem xs={12}>
                                    {this.state.tab === 0 ?
                                        <div
                                            className="text-center displayBlock width-full centerDiv ReportPatientDiv">
                                            <div className="displayInlineDiv">
                                                <div className="padding-10 listTabsActive" style={{width: 150}}
                                                     onClick={this.onChangeTab1}>
                                                    Reports
                                                </div>
                                                <div className="padding-10 listTabsInActive" style={{width: 150}}
                                                     onClick={this.onChangeTab2}>
                                                    Appointments
                                                </div>
                                                <div className="padding-10 listTabsInActive" style={{width: 150}}
                                                     onClick={this.onChangeTab3}>
                                                    Prescriptions
                                                </div>
                                            </div>
                                            <br/><br/>
                                            <div>
                                                <div>

                                                    <ReactTable
                                                        data={data.reports}
                                                        filterable
                                                        noDataText="No Reports"
                                                        defaultFilterMethod={(filter, row) =>
                                                        String(row[filter.id]) === filter.value}
                                                        columns={[
                                                            {
                                                                columns: [
                                                                    {
                                                                        Header: "Report Name",
                                                                        id: "title",
                                                                        accessor: "title",
                                                                        filterMethod: (filter, rows) =>
                                                                            matchSorter(rows, filter.value, {keys: ["title"]}),
                                                                        filterAll: true
                                                                    },
                                                                    {
                                                                        Header: "Report Type",
                                                                        id: "type",
                                                                        accessor: "type",
                                                                        filterMethod: (filter, rows) =>
                                                                            matchSorter(rows, filter.value, {keys: ["type"]}),
                                                                        filterAll: true
                                                                    },
                                                                    {
                                                                        Header: "Clinic",
                                                                        id: "clinic_id.name",
                                                                        accessor: "clinic_id.name",
                                                                        filterMethod: (filter, rows) =>
                                                                            matchSorter(rows, filter.value, {keys: ["clinic_id.name"]}),
                                                                        filterAll: true
                                                                    },
                                                                    /*{
                                                                     Header: "Paid",
                                                                     accessor: "paid",
                                                                     filterMethod: (filter, rows) =>
                                                                     matchSorter(rows, filter.value, {keys: ["paid"]}),
                                                                     Cell: ({index}) =>
                                                                     (<GridContainer>
                                                                     <GridItem>
                                                                     {data.reports[index].paid ? "Yes" : "No"}
                                                                     </GridItem>
                                                                     </GridContainer>
                                                                     ),
                                                                     filterable: false,
                                                                     sortable: false,
                                                                     maxWidth: 100,
                                                                     style: {'textAlign': 'center'}
                                                                     },*/
                                                                    {
                                                                        Header: "Date",
                                                                        accessor: "date",
                                                                        filterMethod: (filter, rows) =>
                                                                            matchSorter(rows, filter.value, {keys: ["created_at"]}),
                                                                        Cell: ({index}) =>
                                                                            (<GridContainer>
                                                                                    <GridItem>
                                                                                        {data.reports[index].created_at ? getDateConverter(new Date(data.reports[index].created_at)) : "No Date"}
                                                                                    </GridItem>
                                                                                </GridContainer>
                                                                            ),
                                                                        filterable: false,
                                                                        sortable: false
                                                                    },
                                                                    {
                                                                        Header: 'Actions',
                                                                        id: 'request_state',
                                                                        filterable: false,
                                                                        sortable: false,
                                                                        maxWidth: 150,
                                                                        Cell: ({index}) =>
                                                                            (<div>
                                                                                    <NavLink
                                                                                        to={data.reports[index] ? dashboardRouter(`/report/view/${data.reports[index]._id}`) : dashboardRouter(`/`)}>
                                                                                        <Button type="button"
                                                                                                color="info"
                                                                                                style={{
                                                                                                    padding: 3,
                                                                                                    left: 0
                                                                                                }}
                                                                                        >
                                                                                            <Icon
                                                                                                style={{fontSize: 22}}>info</Icon>
                                                                                        </Button></NavLink>
                                                                                    <NavLink
                                                                                        to={dashboardRouter(`/report/update/${data.reports[index]._id}`)}>
                                                                                        <Button
                                                                                            type="button"
                                                                                            color="success"
                                                                                            style={{
                                                                                                padding: 3,
                                                                                                left: 20
                                                                                            }}>
                                                                                            <Icon
                                                                                                style={{fontSize: 22}}>edit</Icon>
                                                                                        </Button></NavLink>
                                                                                    {/*<Button type="button" color="danger"*/}
                                                                                    {/*style={{padding: 3, left: 40}}*/}
                                                                                    {/*onClick={this.DeleteAlert('Delete', data[index].clinic_id)}*/}
                                                                                    {/*>*/}
                                                                                    {/*<Icon style={{fontSize: 22}}>close</Icon>*/}
                                                                                    {/*</Button>*/}
                                                                                </div>
                                                                            )
                                                                    }
                                                                ]
                                                            }
                                                        ]}
                                                        defaultPageSize={5}
                                                        className="-striped -highlight"
                                                    />
                                                    <br/><br/><br/>
                                                </div>
                                            </div>
                                        </div> : null}
                                    {this.state.tab === 1 ?
                                        <div
                                        className="text-center displayBlock width-full centerDiv ReportPatientDiv">
                                        <div className="displayInlineDiv">
                                            <div className="padding-10 listTabsInActive" style={{width: 150}}
                                                 onClick={this.onChangeTab1}>
                                                Reports
                                            </div>
                                            <div onClick={this.onChangeTab2} className="padding-10 listTabsActive"
                                                 style={{width: 150}}>
                                                Appointments
                                            </div>
                                            <div className="padding-10 listTabsInActive" style={{width: 150}}
                                                 onClick={this.onChangeTab3}>
                                                Prescriptions
                                            </div>
                                        </div>
                                        <br/><br/>
                                        <div>
                                            <ReactTable
                                                data={data.appointments}
                                                filterable
                                                noDataText="No Appointments"
                                                defaultFilterMethod={(filter, row) =>
                                                String(row[filter.id]) === filter.value}
                                                columns={[
                                                    {
                                                        columns: [
                                                            {
                                                                Header: "Clinic",
                                                                id: "clinic_id.name",
                                                                accessor: "clinic_id.name",
                                                                filterMethod: (filter, rows) =>
                                                                    matchSorter(rows, filter.value, {keys: ["clinic_id.name"]}),
                                                                filterAll: true
                                                            },
                                                            {
                                                                Header: "Doctor",
                                                                id: "doctor_id.display_name",
                                                                accessor: "doctor_id.display_name",
                                                                filterMethod: (filter, rows) =>
                                                                    matchSorter(rows, filter.value, {keys: ["doctor_id.display_name"]}),
                                                                filterAll: true
                                                            },
                                                            {
                                                                Header: "Service",
                                                                id: "service_id.service",
                                                                accessor: "service_id.service",
                                                                filterMethod: (filter, rows) =>
                                                                    matchSorter(rows, filter.value, {keys: ["service_id.service"]}),
                                                                filterAll: true
                                                            },
                                                            {
                                                                Header: "Date",
                                                                accessor: "date_string",
                                                                filterMethod: (filter, rows) =>
                                                                    matchSorter(rows, filter.value, {keys: ["date_string"]}),
                                                                Cell: ({index}) =>
                                                                    (<GridContainer>
                                                                            <GridItem>
                                                                                {data.appointments[index] ? (data.appointments[index].local_date_string ? getDateConverterReversal(data.appointments[index].local_date_string) : getDateConverter(data.appointments[index].date_string)) : "No Date"}
                                                                            </GridItem>
                                                                        </GridContainer>
                                                                    ),
                                                                filterable: false
                                                            },
                                                            {
                                                                Header: "Time",
                                                                id: "local_start_time",
                                                                accessor: "local_start_time",
                                                                filterMethod: (filter, rows) =>
                                                                    matchSorter(rows, filter.value, {keys: ["local_start_time"]}),
                                                                filterAll: true
                                                            },

                                                            {
                                                                Header: "Status",
                                                                accessor: "status",
                                                                filterMethod: (filter, rows) =>
                                                                    matchSorter(rows, filter.value, {keys: ["status"]}),
                                                                filterAll: true
                                                            },
                                                            {
                                                                Header: 'Actions',
                                                                id: 'request_state',
                                                                filterable: false,
                                                                sortable: false,
                                                                maxWidth: 150,
                                                                Cell: ({index}) =>
                                                                    (<div>
                                                                            <NavLink
                                                                                to={data.appointments[index] ? dashboardRouter(`/appointment/view/${data.appointments[index]._id}`) : dashboardRouter(`/`)}>
                                                                                <Button type="button" color="info"
                                                                                        style={{padding: 3, left: 0}}
                                                                                >
                                                                                    <Icon
                                                                                        style={{fontSize: 22}}>info</Icon>
                                                                                </Button></NavLink>
                                                                            <NavLink
                                                                                to={dashboardRouter(`/appointment/update/${data.appointments[index]._id}`)}>
                                                                                <Button
                                                                                    type="button" color="success"
                                                                                    style={{padding: 3, left: 20}}>
                                                                                    <Icon
                                                                                        style={{fontSize: 22}}>edit</Icon>
                                                                                </Button></NavLink>
                                                                            {/*<Button type="button" color="danger"*/}
                                                                            {/*style={{padding: 3, left: 40}}*/}
                                                                            {/*onClick={this.DeleteAlert('Delete', data[index].clinic_id)}*/}
                                                                            {/*>*/}
                                                                            {/*<Icon style={{fontSize: 22}}>close</Icon>*/}
                                                                            {/*</Button>*/}
                                                                        </div>
                                                                    )
                                                            }
                                                        ]
                                                    }
                                                ]}
                                                defaultPageSize={5}
                                                className="-striped -highlight"
                                            />
                                        </div>
                                    </div> : null}
                                    {this.state.tab === 2 ?
                                        <div
                                            className="text-center displayBlock width-full centerDiv ReportPatientDiv">
                                            <div className="displayInlineDiv">
                                                <div className="padding-10 listTabsInActive" style={{width: 150}}
                                                     onClick={this.onChangeTab1}>
                                                    Reports
                                                </div>
                                                <div onClick={this.onChangeTab2} className="padding-10 listTabsInActive"
                                                     style={{width: 150}}>
                                                    Appointments
                                                </div>
                                                <div className="padding-10 listTabsActive" style={{width: 150}}
                                                     onClick={this.onChangeTab3}>
                                                    Prescriptions
                                                </div>
                                            </div>
                                            <br/><br/>
                                            <div>
                                                <ReactTable
                                                    data={data.prescriptions}
                                                    filterable
                                                    noDataText="No Prescriptions"
                                                    defaultFilterMethod={(filter, row) =>
                                                    String(row[filter.id]) === filter.value}
                                                    columns={[
                                                        {
                                                            columns: [
                                                                {
                                                                    Header: "Clinic",
                                                                    id: "clinic_id.name",
                                                                    accessor: "clinic_id.name",
                                                                    filterMethod: (filter, rows) =>
                                                                        matchSorter(rows, filter.value, {keys: ["clinic_id.name"]}),
                                                                    filterAll: true
                                                                },
                                                                {
                                                                    Header: "Ref By",
                                                                    id: "ref_by",
                                                                    accessor: "ref_by",
                                                                    filterMethod: (filter, rows) =>
                                                                        matchSorter(rows, filter.value, {keys: ["ref_by"]}),
                                                                    filterAll: true
                                                                },
                                                                {
                                                                    Header: "Date",
                                                                    accessor: "date",
                                                                    filterMethod: (filter, rows) =>
                                                                        matchSorter(rows, filter.value, {keys: ["date"]}),
                                                                    Cell: ({index}) =>
                                                                        (<GridContainer>
                                                                                <GridItem>
                                                                                    {data.prescriptions[index] ? (data.prescriptions[index].date ? getDateConverter(data.prescriptions[index].date) : getDateConverter(data.appointments[index].date_string)) : "No Date"}
                                                                                </GridItem>
                                                                            </GridContainer>
                                                                        ),
                                                                    filterable: false
                                                                },
                                                                {
                                                                    Header: 'Actions',
                                                                    id: 'request_state',
                                                                    filterable: false,
                                                                    sortable: false,
                                                                    maxWidth: 150,
                                                                    Cell: ({index}) =>
                                                                        (<div>
                                                                                <NavLink
                                                                                    to={data.prescriptions[index] ? dashboardRouter(`/prescription/view/${data.prescriptions[index]._id}`) : dashboardRouter(`/`)}>
                                                                                    <Button type="button" color="info"
                                                                                            style={{padding: 3, left: 0}}
                                                                                    >
                                                                                        <Icon
                                                                                            style={{fontSize: 22}}>info</Icon>
                                                                                    </Button></NavLink>
                                                                                {/*<Button type="button" color="danger"*/}
                                                                                {/*style={{padding: 3, left: 40}}*/}
                                                                                {/*onClick={this.DeleteAlert('Delete', data[index].clinic_id)}*/}
                                                                                {/*>*/}
                                                                                {/*<Icon style={{fontSize: 22}}>close</Icon>*/}
                                                                                {/*</Button>*/}
                                                                            </div>
                                                                        )
                                                                }
                                                            ]
                                                        }
                                                    ]}
                                                    defaultPageSize={5}
                                                    className="-striped -highlight"
                                                />
                                            </div>
                                        </div> : null}
                                </GridItem>
                            </GridContainer>

                        </CardBody>
                    </Card>
                </div>
            )
        }
        else if (this.state.notFound !== null) {
            return <h2 className="text-center">Data Not Found</h2>
        }
        else return (<div>
                <Loader/></div>)
    }

    CallReadApi(patientID) {
        var postBody = {

            "clinic_master_id": "",
            "_id": patientID
        };
        api.fetchPatientDetailsByClinicMasterAndPatientID(postBody).then(json => {
            this.setState({data: json.data.data[0]})
        }).catch(error => {
            this.setState({notFound: error})
        });
    }

    DeleteAlert = (param1, param2) => (e) => {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Are you sure you want to
                        Delete?</DialogTitle>

                    <DialogActions>
                        <Button onClick={this.hideDeleteAlert}>
                            Disagree
                        </Button>
                        <Button onClick={this.CallDeleteApi} color="danger" autoFocus>
                            Agree
                        </Button>
                    </DialogActions>
                </Dialog>
            ),
            selectedId: param2
        });
    }

    hideDeleteAlert = () => {
        this.setState({
            alert: null
        });
    }

    CallDeleteApi() {
        api.deletePatientById(this.state.clickedId).then(json => {
            this.setState({alert: null, redirectAll: true});
            this.props.history.push(dashboardRouter(`/patient/readPatients`))
        })

    }
}






// WEBPACK FOOTER //
// ./src/views/Patients/onePatient.jsx